import { render, staticRenderFns } from "./InitResult.vue?vue&type=template&id=d9ef0da8&scoped=true"
import script from "./InitResult.vue?vue&type=script&lang=js"
export * from "./InitResult.vue?vue&type=script&lang=js"
import style0 from "./InitResult.vue?vue&type=style&index=0&id=d9ef0da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ef0da8",
  null
  
)

export default component.exports